<div id="dv{{componentName}}" class="h-100" style="background-color: #fff; padding: 10px;">
	<table [hidden]="showBackCard" class="h-100 w-100">
		<tr style="height:40px;">
			<td class="jmPageTitle">
				{{directiveTitle}}
				<i role="button" (click)="toggleBackCard()" class="jmInfoCircle" style="vertical-align: unset;margin:0px 10px;"></i>
			</td>
		</tr>
		<tr *ngIf="retrievingData">
			<td class="text-center" style="margin-top:8%;">
				<span class="jmWidgetLoadingIcon40"></span>
			</td>
		</tr>
		<tr *ngIf="!retrievingData && compares==null">
			<td>
				No results found. Please try other location.
			</td>
		</tr>
		<tr *ngIf="!retrievingData && compares!=null" style="height:30px; text-align:center; font-size:0.9em">
			<td>
				<span *ngIf="localName!==''" style="padding-right:20px;"><i [ngClass]="chartLegend" [ngStyle]="{'color': chartColors[0]}"></i> {{localName}} <span *ngIf="!hasLocalData"> (No Data)</span></span>
				<span *ngIf="nationalName!==''" style="white-space:nowrap;"><i [ngClass]="chartLegend" [ngStyle]="{'color':chartColors[1]}"></i> {{nationalName}}</span>
			</td>
		</tr>
		<tr *ngIf="!retrievingData && compares!=null">
			<td>
				<div id="dv{{componentName}}Chart" class="h-100 text-center" style="max-width:95%; margin:auto;">
					<google-chart *ngIf="chartData.isReady"
								  [title]="chartData.title"
								  [type]="chartData.type"
								  [data]="chartData.data"
								  [columns]="chartData.columnNames"
								  [options]="chartData.options"
								  [formatters]="chartData.formatters"
								  [width]="chartData.width"
								  [height]="chartData.height">
					</google-chart>
					<span *ngIf="!chartData.isReady" class="jmWidgetLoadingIcon40" style="margin-top:8%;"></span>
				</div>
			</td>
		</tr>
	</table>

	<table [hidden]="!showBackCard" class="h-100 w-100">
		<tr style="height:45px;">
			<td class="jmPageTitle">
				{{directiveTitle}}
				<button (click)="toggleBackCard()" class="jmCloseBtn float-end"></button>
			</td>
		</tr>
		<tr>
			<td>
				<div style="padding: 10px 0px">Data provided by the Bureau of Labor Statistics.</div>
				<div style="padding: 5px 0px">For more information please visit:</div>
				<div *ngIf="reportTypeId===1">
					Local - <a href="https://data.bls.gov/cgi-bin/surveymost?la" target="_blank">https://data.bls.gov/cgi-bin/surveymost?la</a><br />
					National - <a href="https://data.bls.gov/cgi-bin/surveymost?bls" target="_blank">https://data.bls.gov/cgi-bin/surveymost?la</a>
				</div>
				<div *ngIf="reportTypeId===2">
					All Industries - <a href="https://data.bls.gov/cgi-bin/surveymost?la" target="_blank">https://data.bls.gov/cgi-bin/surveymost?la</a><br />
					Information - <a href="https://data.bls.gov/PDQWeb/en" target="_blank">https://data.bls.gov/PDQWeb/en</a>
				</div>
				<div *ngIf="reportTypeId===3">
					All Industries - <a href="https://beta.bls.gov/maps/cew/US?chartData=6" target="_blank">https://beta.bls.gov/maps/cew/US?chartData=6</a><br />
					Information - <a href="https://data.bls.gov/PDQWeb/en" target="_blank">https://data.bls.gov/PDQWeb/en</a>
				</div>
				<div *ngIf="reportTypeId===4">
					All Industries - <a href="https://beta.bls.gov/maps/cew/US?chartData=1" target="_blank">https://beta.bls.gov/maps/cew/US?chartData=1</a><br />
					Information - <a href="https://data.bls.gov/PDQWeb/en" target="_blank">https://data.bls.gov/PDQWeb/en</a>
				</div>
			</td>
		</tr>
	</table>
</div>
